import { render } from "./BusinessEmployees.vue?vue&type=template&id=58eb5576&scoped=true"
import script from "./BusinessEmployees.vue?vue&type=script&lang=js"
export * from "./BusinessEmployees.vue?vue&type=script&lang=js"

import "./BusinessEmployees.vue?vue&type=style&index=0&id=58eb5576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eb5576"]])

export default __exports__